module.exports = __webpack_public_path__ + "static/media/S (150).966de222.jpg";